import React, { useState } from "react";

const carouselImages = [
  {
    src: "/assets/home/pixxgen-home.png",
    alt: "Pixxgen Products",
  },
  {
    src: "/assets/home/shimadzu-home.png",
    alt: "Shimadzu Products",
  },
  {
    src: "/assets/home/gel-pads-home.png",
    alt: "Gel Pads",
  },
];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = carouselImages.length;

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };
  const goToNext = () => {
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  return (
    <div className="page-container home-page">
      {/* Welcome Section */}
      <section className="home-card welcome-card">
        <p className="paragraph">
          Indelect Technologies Pvt.Ltd. established in the year 1995 by the
          Technocrats having over 18 years of combined expertise in technology
          and mentoring experience in advanced areas of Biomedical Engineering,
          Medical Imaging Technology and Power Electronics.
          <br />
          <br />
          Indelect, over these years has acclaimed a high reputation in the
          international markets apart from serving the domestic Indian market.
          With a sustainable and consistently growing progress, Indelect
          Technologies Pvt. Ltd. has evolved into a dominant player in the
          distribution of Biomedical, Medical Imaging & Power Electronic
          equipments. The organization has expanded vastly in its length and
          breadth and has its foot firmly grounded to diverse activities.
        </p>
      </section>

      {/* Carousel Section */}
      <section className="home-card carousel-card">
        <div className="custom-carousel">
          <button
            className="carousel-nav carousel-nav-left"
            aria-label="Previous slide"
            onClick={goToPrev}
          >
            &#8592;
          </button>
          <img
            className="carousel-image"
            src={carouselImages[currentSlide].src}
            alt={carouselImages[currentSlide].alt}
          />
          <button
            className="carousel-nav carousel-nav-right"
            aria-label="Next slide"
            onClick={goToNext}
          >
            &#8594;
          </button>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="home-card portfolio-card">
        <div className="portfolio-grid">
          <div className="portfolio-column">
            <div className="portfolio-title">Radiology</div>
            <ul className="stylized-list-ul">
              <li className="stylized-list-li">Shimadzu X-Ray Systems</li>
              <li className="stylized-list-li">Genuine X-Ray Systems</li>
              <li className="stylized-list-li">Pixxgen DR Systems</li>
            </ul>
          </div>
          <div className="portfolio-column">
            <div className="portfolio-title">Segments</div>
            <ul className="stylized-list-ul">
              <li className="stylized-list-li">Human</li>
              <li className="stylized-list-li">Veterinary</li>
            </ul>
          </div>
          <div className="portfolio-column">
            <div className="portfolio-title">Specialty</div>
            <ul className="stylized-list-ul">
              <li className="stylized-list-li">
                Neuro Surgical Stereotactic Device
              </li>
              <li className="stylized-list-li">
                Surgical Instruments and Gelpads
              </li>
            </ul>
          </div>
          <div className="portfolio-column">
            <div className="portfolio-title">Support</div>
            <ul className="stylized-list-ul">
              <li className="stylized-list-li">X-Ray Equipments</li>
              <li className="stylized-list-li">
                QA Services for Diagnostics Radiology Equipments
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Home;
